import { EmployeesPageConfig } from '../components/Employee/configs/employeesPageConfig';
import { EmployeeDetailsPageConfig } from '../components/Employee/configs/employeeDetailsPageConfig';
import { ProjectsPageConfig } from '../components/Project/configs/projectsPageConfig';
import { HeadcountPageConfig } from './routesConfigs/headcountPageConfig';
import { TurnoverPageConfig } from './routesConfigs/turnoverPageConfig';
import { BenchPageConfig } from '../components/Bench/configs/benchPageConfig';
import { LeavesPageConfig } from '../components/Leaves/configs/leavesPageConfig';
import { OnboardingPageConfig } from '../components/Onboarding/configs/onboardingPageConfig';
import { OffboardingPageConfig } from '../components/Offboarding/configs/offboardingPageConfig';
import { RisksPageConfig } from '../components/Risks/configs/risksPageConfig';
import { ConfigurationPageConfig } from '../components/Configuration/configs/configurationPageConfig';
import { NotFoundPageConfig } from './routesConfigs/notFoundPageConfig';


const routesConfig = [
  EmployeesPageConfig,
  BenchPageConfig,
  LeavesPageConfig,
  ProjectsPageConfig,
  RisksPageConfig,
  OnboardingPageConfig,
  OffboardingPageConfig,
  HeadcountPageConfig,
  TurnoverPageConfig,
  ConfigurationPageConfig,
  EmployeeDetailsPageConfig,
  NotFoundPageConfig,
];

export default routesConfig;
